// shared/protocol — secret: REST + WS message envelope, versioning, error shape.
// Imported by client/net AND server/api. Mismatch fails handshake.

import { z } from 'zod';

export const PROTOCOL_VERSION = 1 as const;

export const ProtocolErrorSchema = z.object({
  code: z.string(),
  message: z.string(),
  detail: z.unknown().optional(),
});
export type ProtocolError = z.infer<typeof ProtocolErrorSchema>;

export const HandshakeSchema = z.object({
  type: z.literal('handshake'),
  protocolVersion: z.number().int(),
});
export type Handshake = z.infer<typeof HandshakeSchema>;

export const HandshakeAckSchema = z.object({
  type: z.literal('handshake_ack'),
  protocolVersion: z.number().int(),
  serverTime: z.number().int(),
});
export type HandshakeAck = z.infer<typeof HandshakeAckSchema>;

// Phase 5 will extend with market, leaderboard, season messages.
// Each message is a discriminated union member added here.
export const WireMessageSchema = z.discriminatedUnion('type', [
  HandshakeSchema,
  HandshakeAckSchema,
]);
export type WireMessage = z.infer<typeof WireMessageSchema>;

export function encode(msg: WireMessage): string {
  return JSON.stringify(WireMessageSchema.parse(msg));
}

export function decode(raw: string): WireMessage {
  return WireMessageSchema.parse(JSON.parse(raw));
}
